// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#loading{width:200px;height:100px;z-index:1000}#loading,.spinner:after{position:fixed;top:50%;left:50%}.spinner:after{content:\"\";box-sizing:border-box;width:64px;height:64px;margin-top:-32px;margin-left:-32px;border-radius:50%;border:4px solid #d3d3d3;border-top-color:#2849d1;animation:spinner .8s linear infinite}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
